export const EXTENSION_SLUG = 'ws-navigation';
export const VARIABLE_NAME = 'navigation';
export const NAVIGATION_GLOBAL_ID = 'nav-menu';
export const CONTEXT_MENU_GROUP_NAME = 'navigation';
export const CONVERT_TO_LOCAL_CONTEXT_MENU_ITEM_ID = 'convert-global-to-local-element';
export const CONVERT_TO_GLOBAL_CONTEXT_MENU_ITEM_ID = 'convert-local-element-to-global';
